<script>
export default {
  props: {
    message: String,
    type: String,
    errors: Object,
    id: String,
    height: String,
    persistTime: Number,
  },
  created() {
    // console.log('created toast with id', this.id)
    setTimeout(
      () => {
        // console.log('will send destroy evt', this.id)
        this.$emit('destroy', this.id)
      },
      this.persistTime ? this.persistTime : 4000,
    )
    if (this.errors) {
      console.log('errors parsed', JSON.parse(this.errors))
    }
  },
}
</script>

<template lang="pug">
.toast(:class="{ success: type == 'success', error: type == 'error', warning: type == 'warning' }") {{ message }}
</template>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';
.toast {
  color: #fff;
  min-width: 250px;
  max-width: 80vw;
  overflow: hidden;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 38px;
  opacity: 1;
  font-size: 16px;
  line-height: 21px;
  position: relative;
  background: #dadada;
  margin-top: 3rem;
  margin-bottom: 10px;
  z-index: 9;
  text-align: center;
  border-radius: 4px;
  font-weight: bold;

  &.success {
    background: rgba(236, 41, 116, 0.9);
  }

  &.warning {
    background: rgba(236, 41, 116, 0.9);
  }

  &.error {
    background: rgba(236, 41, 116, 0.9);
  }
}
</style>
